import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-page-section',
  standalone: true,
  templateUrl: './page-section.html',
  styleUrl: './page-section.scss'
})
export class PageSection {
  @Input() sectionClass = '';
  @Input() containerClass = 'container';
  @Input() withOffset = true;
}